import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, OperatorFunction } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BankModel, UpdateBankPayload } from 'src/app/models/bank.model';
import { BankListAvailModel } from 'src/app/models/bank-list-avail.model';
import { ProfileService } from 'src/app/services/profile.service';
import { ModalPinComponent } from '../../../profile/components/modal-pin-verification/modal-pin-verification.component';
import { BuatPinComponent } from 'src/app/pages/dashboard/components/modal-buat-pin/buat-pin.component';

@Component({
  selector: 'app-rekening-item',
  templateUrl: './rekening-item.component.html',
  standalone: false,
})
export class RekeningItemComponent implements OnInit, OnChanges {
  @Input() item!: BankModel;
  @Input() loading: boolean = false;
  @Input() bankNameList: BankListAvailModel[] = [];
  @Input() pinToken: string = '';

  @Output() onEdit = new EventEmitter<BankModel>();
  @Output() onCancel = new EventEmitter<BankModel>();
  @Output() onSave = new EventEmitter<UpdateBankPayload>();
  @Output() filterResult = new EventEmitter<UpdateBankPayload>();

  constructor(
    private modalService: NgbModal,
    private profileService: ProfileService
  ) {}

  editPayload!: UpdateBankPayload;
  isDisSave: boolean = false;

  formatter = (x: { bank_name: string } | string) => {
    if (typeof x === 'string') return x;
    return x.bank_name;
  };

  search: OperatorFunction<string, readonly BankListAvailModel[]> = (
    text$: Observable<string>
  ) =>
    text$.pipe(
      debounceTime(1000),
      map((term) =>
        term === ''
          ? []
          : this.bankNameList
              .filter(
                (v: BankListAvailModel) =>
                  v.bank_name.toLowerCase().indexOf(term.toLowerCase()) > -1
              )
              .slice(0, 10)
      )
    );

  ngOnInit() {
    this.initEditPayload();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pinToken'] || (changes['item'] && !this.item.isDisable)) {
      this.initEditPayload();
    }
  }

  initEditPayload() {
    this.editPayload = {
      id: this.item.id,
      bank_code: this.item.bank_code,
      bank_name: this.item.bank_name,
      bank_number: this.item.bank_number,
      bank_owner: this.item.bank_owner,
      pin_token: this.pinToken || this.item.pin_token || '',
    };
  }

  edit() {
    this.item.isDisable = false;
    this.initEditPayload();
    this.onEdit.emit(this.item);
  }

  batal() {
    this.item.isDisable = true;
    this.item.isEmptyBank = false;
    this.item.isEmptyRek = false;
    this.item.isEmptyOwn = false;
    this.item.pin_token = '';
    this.pinToken = '';
    this.initEditPayload();
    this.onCancel.emit(this.item);
  }

  simpan() {
    if (!this.editPayload.bank_owner)
      this.editPayload.bank_owner = this.item.bank_owner;
    if (!this.editPayload.bank_number)
      this.editPayload.bank_number = this.item.bank_number;
    if (!this.editPayload.bank_name) {
      this.editPayload.bank_name = this.item.bank_name;
      this.editPayload.bank_code = this.item.bank_code;
    }

    const profile = this.profileService.profileDataSubject.value;
    if (!profile?.pin_status) {
      this.modalService.open(BuatPinComponent, {
        backdrop: 'static',
        centered: true,
      });
      return;
    }

    const modal = this.modalService.open(ModalPinComponent, {
      backdrop: 'static',
      centered: true,
    });

    const modalInstance = modal.componentInstance as ModalPinComponent;
    modalInstance.loading.subscribe((res: any) => {
      this.pinToken = res?.pin_token || '';
      this.editPayload.pin_token = this.pinToken;
      this.filterResult.emit(this.editPayload);
      this.onSave.emit(this.editPayload);
    });
  }

  onEditBankName(value: string | BankListAvailModel) {
    if (value && typeof value === 'object' && 'bank_name' in value) {
      this.editPayload.bank_name = value.bank_name;
      this.editPayload.bank_code = value.bank_code;
    } else {
      this.editPayload.bank_name = value;
      this.editPayload.bank_code = '';
    }

    this.filterResult.emit(this.editPayload);

    if (!value || value === '') {
      this.item.isEmptyBank = true;
      this.isDisSave = true;
    } else if (this.editPayload.bank_name === this.item.bank_name) {
      this.isDisSave = true;
    } else {
      this.item.isEmptyBank = false;
      this.isDisSave = false;
    }
  }

  onEditBankNumber(value: string) {
    this.editPayload.bank_number = value;
    this.filterResult.emit(this.editPayload);

    if (!value || value === '') {
      this.item.isEmptyRek = true;
      this.isDisSave = true;
    } else if (value === this.item.bank_number) {
      this.isDisSave = true;
    } else {
      this.item.isEmptyRek = false;
      this.isDisSave = false;
    }
  }

  onEditBankOwner(value: string) {
    this.editPayload.bank_owner = value;
    this.filterResult.emit(this.editPayload);

    if (!value || value === '') {
      this.item.isEmptyOwn = true;
      this.isDisSave = true;
    } else if (value === this.item.bank_owner) {
      this.isDisSave = true;
    } else {
      this.item.isEmptyOwn = false;
      this.isDisSave = false;
    }
  }
}
